// @flow

import React from 'react';
import { Menu, Button } from 'semantic-ui-react';

type Props = {
  onAddQuestion: () => void,
};

const styles = {
  button: {
    height: '36px',
  },
};

const QuestionsMenu = ({ onAddQuestion }: Props) => {
  return (
    <Menu size="small" attached>
      <Menu.Item header className="borderless">
        Liste des questions
      </Menu.Item>
      <Menu.Menu position="right">
        <Menu.Item>
          <div>
            <Button
              style={styles.button}
              type="button"
              icon="add"
              labelPosition="right"
              content="Ajouter"
              onClick={onAddQuestion}
            />
          </div>
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
};

export default QuestionsMenu;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionsMenu.js